// frontend/src/components/CookieConsentModal/CookieConsentModal.jsx

// 1. Import useTranslation and the Trans component
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import './CookieConsentModal.css';

const CookieConsentModal = ({ isOpen, onAccept }) => {
  const location = useLocation();
  // 2. Initialize the translation hook
  const { t } = useTranslation();

  const excludedPages = ['/privacy-policy', '/terms-of-service', '/verify'];
  // Check if current path STARTS with any of the excluded paths
  // Using .startsWith handles '/verify?id=...' correctly if location.pathname is just '/verify'
  // But if location.pathname includes query params (rare in React Router, usually it's separate), 
  // it's safer to just check exact matches or startsWith.
  const isExcludedPage = excludedPages.some(path => location.pathname.startsWith(path));

  if (!isOpen || isExcludedPage) {
    return null;
  }

  return (
    <div className="cookie-modal-overlay">
      <div className="cookie-modal-content">
        {/* 3. Replace hardcoded text with the t() function */}
        <h2 className="cookie-modal-title">
          {t('cookieConsent.title')}
        </h2>
        <p>
          {t('cookieConsent.description1')}
        </p>
        
        {/* For text with simple HTML like <strong>, the t function works,
            but using Trans is safer and more consistent. */}
        <p>
          <Trans i18nKey="cookieConsent.description2">
            <strong>We do not use third-party tracking or advertising cookies.</strong> Your privacy is fundamental to our mission.
          </Trans>
        </p>
        
        <p>
          {/* 4. Use the <Trans> component for complex strings with links */}
          <Trans i18nKey="cookieConsent.agreement">
            {/* The components here will replace the <0> and <1> placeholders */}
            <Link to="/privacy-policy" className="cookie-modal-link" />
            <Link to="/terms-of-service" className="cookie-modal-link" />
          </Trans>
        </p>

        <div className="cookie-modal-button-wrapper">
          <button
            onClick={onAccept}
            className="cookie-modal-button"
          >
            {t('cookieConsent.acceptButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentModal;